import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { useAuthContext } from '../../contexts/AuthContext';
import { querystring } from '../../utils/RouteHelper';

export default function UnauthenticatedRoute() {
  const { isAuthenticated } = useAuthContext();

  const redirect = querystring('redirect');
  const navigate = useNavigate();
  useEffect(() => {
    if (isAuthenticated) {
      navigate(redirect === '' || redirect === null ? '/' : redirect, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);
  return <Outlet />;
}
